import { useModal } from '@shared/model/useModal';

export const useProgressReferralModal = () => useModal('progress-referral-modal')